import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import {AuthProvider, useAuth} from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import MfaVerification from "./components/MfaVerification";

const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {

        return <div>Laden...</div>;
    }

    return user ? children : <Navigate to="/login" replace />;
};

const App = () => {
    return (

            <Router>
                <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/mfa-verify" element={<MfaVerification />} />
                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <Dashboard/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            <PrivateRoute>
                                <Dashboard/>
                            </PrivateRoute>
                        }
                    />
                </Routes>
                </AuthProvider>
            </Router>

    );
};

export default App;